import gsap from "gsap";

document.addEventListener("DOMContentLoaded", function () {
  const websiteList = document.getElementById('website-list');
  if (!websiteList) return;

  const yearEl = document.querySelector('.current-slide .year');
  const titleEl = document.querySelector('.current-slide .title');

  // Parse data from #website-list
  const titles = websiteList.getAttribute('data-title')
    .replace(/^\[|\]$/g, '')
    .split(',')
    .map(t => t.trim())
    .filter(Boolean);

  const years = websiteList.getAttribute('data-year')
    .split(',')
    .map(y => y.trim())
    .filter(Boolean);

  // Shuffle indices for random rotation
  const indices = Array.from({ length: Math.max(titles.length, years.length) }, (_, i) => i);
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  const shuffledIndices = shuffle([...indices]);
  let idx = 0;

  // Animate out text per character
  function animateOutText(el, onComplete) {
    const chars = el.querySelectorAll('span');
    gsap.to(chars, {
      opacity: 0,
      x: 10,
      filter: 'blur(8px)',
      duration: 0.3,
      stagger: 0.01,
      ease: "power2.in",
      onComplete
    });
  }

  // Animate in text per character (like .trailers-title)
  function animateInText(el, text) {
    el.innerHTML = '';
    text.split('').forEach(char => {
      const span = document.createElement('span');
      if (char === ' ') {
        span.textContent = '\u00A0';
        span.setAttribute('data-space', 'true');
      } else {
        span.textContent = char;
      }
      span.style.display = 'inline-block';
      span.style.opacity = 0;
      span.style.filter = 'blur(8px)';
      el.appendChild(span);
    });
    const chars = el.querySelectorAll('span');
    gsap.to(chars, {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      duration: 0.5,
      stagger: 0.03,
      ease: "power2.out",
      delay: 0.1
    });
  }

  function rotateNav() {
    idx = (idx + 1) % shuffledIndices.length;
    const i = shuffledIndices[idx];

    // Animate out title first, then year slightly after
    animateOutText(titleEl, () => animateInText(titleEl, titles[i] || ''));
    setTimeout(() => {
      animateOutText(yearEl, () => animateInText(yearEl, years[i] || ''));
    }, 150); // 150ms delay for a subtle stagger
  }

  // Set initial state with animation
  animateInText(yearEl, years[shuffledIndices[0]] || '');
  animateInText(titleEl, titles[shuffledIndices[0]] || '');
  gsap.set([yearEl, titleEl], { opacity: 1 });

  setInterval(rotateNav, 3000);
});